// Destination Country Step

import React from "react";
import {
  View,
  Text,
  TextInput,
  StyleSheet,
  FlatList,
  Image,
} from "react-native";
import Colors from "../../../constants/colors";
import SearchIcon from "../../../../../../assets/images/searchIcon.png";
import { ComponentStyles } from "../../../constants/componentStyles";

type FlatListDataComponentProps<T> = {
  title?: string;
  subTitle?: string;
  searchPlaceHolder?: string;
  searchValue?: string;
  filteredData?: T[];
  onSearchChangeText: (text: string) => void;
  renderItem: (item: T) => JSX.Element;
  searchTestID?: string;
  flatListTestID?: string;
};

function FlatListDataComponent<T>({
  title,
  subTitle,
  searchPlaceHolder,
  searchValue,
  filteredData,
  onSearchChangeText,
  renderItem,
  searchTestID,
  flatListTestID
}: FlatListDataComponentProps<T>) {

  return (
    <View style={styles.container}>
      {title && <Text style={styles.title}>{title}</Text>}
      {subTitle && <Text style={styles.subtitle}>{subTitle}</Text>}
      <View style={styles.searchContainer}>
        <Image
          source={SearchIcon}
          style={{height: 24, width: 24, marginRight: 8}}
          resizeMode='contain'
        />
        <TextInput
          testID={searchTestID}
          style={styles.searchInput}
          placeholder={searchPlaceHolder}
          value={searchValue}
          onChangeText={onSearchChangeText}
        />
      </View>
      <FlatList
        testID={flatListTestID}
        data={filteredData}
        keyExtractor={(item, index) => index.toString()}
        style={{ flex: 1, width: "100%" }} 
        renderItem={({ item }) => renderItem(item)}
      />
    </View>
  );
}

export default FlatListDataComponent;

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white
  },
  title: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.titleFont,
    fontWeight: '500', 
    color: Colors.titleTextColor,
    lineHeight: 34,
    marginBottom: 8
  },
  subtitle: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.subTitleFont,
    fontWeight: '400',
    lineHeight: 24,
    color: Colors.subTitleColor,
  },
  searchContainer: {
    flexDirection: 'row',
    backgroundColor: Colors.searchBackground,
    padding: 8,
    borderRadius: 24,
    marginBottom: 19,
    marginTop: 24
  },
  searchInput: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.subTitleFont,
    fontWeight: "400",
    lineHeight: 24,
    color: Colors.subTitleColor,
  },
  countryRow: {
    backgroundColor: Colors.white,
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 16,
    borderBottomWidth: 0,
    justifyContent: 'space-between'
  },
  flag: {
    fontSize: 22,
    marginRight: 12,
  },
  countryName: {
    fontSize: 16,
    fontWeight: "400",
    fontFamily: ComponentStyles.textFamily,
    lineHeight: 20,
    color: Colors.darkGrey,
    paddingLeft: 16
  },
  radioContainer: {
    marginLeft: 12,
  },
  radioButton: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#D1D5DB',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.radioButtonFilled
  },
  radioOuter: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: "#D1D5DB",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: '#D1D1D1'
  },
  radioOuterSelected: {
    borderColor: "#000",
  },
  radioInner: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: "#000",
  },
  selectedText: {
    marginTop: 16,
    fontSize: 16,
    fontWeight: "500",
    color: "#111827",
  },
});
